import * as React from 'react';
import { IconProps } from '../types';

const IcMenuTurn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      d="M6.025 3.247c.325-.375.983-.307 1.24.11a.791.791 0 0 1-.064.962c-.615.735-1.268 1.44-1.882 2.175 2.75-.002 5.499.002 8.248 0a3.943 3.943 0 0 1 2.74 1.054c.984.907 1.443 2.34 1.159 3.648-.262 1.338-1.283 2.488-2.577 2.914-.853.306-1.773.181-2.66.212-.37.005-.82.017-1.051-.33-.34-.42-.095-1.13.435-1.247.927-.124 1.894.122 2.798-.174a2.318 2.318 0 0 0 1.506-2.044 2.318 2.318 0 0 0-1.327-2.213c-.525-.265-1.127-.219-1.696-.219-2.527.005-5.054 0-7.58.003.634.747 1.301 1.465 1.925 2.22.364.436.064 1.175-.492 1.256-.32.075-.632-.096-.829-.342L2.481 7.294c1.183-1.347 2.353-2.708 3.544-4.047Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M10.11 9.885c.856-.306 1.776-.176 2.664-.21.37-.008.826-.015 1.052.34.33.424.081 1.121-.444 1.237-.897.119-1.824-.099-2.706.14-.85.269-1.502 1.063-1.587 1.953-.117.957.442 1.944 1.321 2.339.523.263 1.124.219 1.692.218 2.528-.003 5.055.001 7.582-.002-.636-.749-1.305-1.47-1.93-2.228-.328-.402-.107-1.075.386-1.222.346-.132.725.035.94.316l3.436 3.937c-1.096 1.26-2.203 2.513-3.294 3.779-.217.252-.472.542-.838.517-.596.02-1.018-.747-.654-1.229.625-.777 1.31-1.505 1.956-2.265-2.749-.002-5.498-.001-8.246 0a3.954 3.954 0 0 1-2.737-1.043 3.924 3.924 0 0 1-1.145-3.781 3.923 3.923 0 0 1 2.553-2.796Z"
    />
  </svg>
);

export default IcMenuTurn;
